module.exports = __webpack_public_path__ + "img/cc.05f8271b.png";